import { Component } from 'react'

// Last-resort guard so an unexpected render/chunk error shows a recoverable
// message instead of a blank white screen. Stale-chunk import failures are
// already auto-recovered by lazyWithReload; this catches anything that slips
// past (a second failure after the one-time reload, or a render-time crash).
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    // Keep a console trail for debugging; no external reporting.
    console.error('Unhandled application error:', error, info)
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center text-foreground">
        <p className="text-lg font-semibold">Something went wrong.</p>
        <p className="max-w-md text-sm text-muted-foreground">
          The page failed to load. Reloading usually fixes it.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="border border-border bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
        >
          Reload
        </button>
      </div>
    )
  }
}
